import React, { useState } from "react"
import PropTypes from "prop-types"
import get from "lodash.get"
import { Button } from 'antd'
import { usePapaParse } from 'react-papaparse'
import { CloudDownloadOutlined } from "@ant-design/icons"

import ExportColumnShape from "./shapes/ExportColumnShape"

const AFTER_DOWNLOAD_CLEANUP_DELAY = 4e4 // 40s

const createDownload = (fileName, content) => {
  const blob = new Blob([ content ], { type: 'text/csv' })

  const url = window.URL.createObjectURL(blob)
  const timestamp = new Date().getTime()

  const element = document.createElement('a')
  element.setAttribute('hidden', '')
  element.setAttribute('href', url)
  element.setAttribute('download', `${fileName}_${timestamp}.csv`)

  return element
}

const getData = (columns, items) => {
  const hasColumns = columns.length > 0

  if (!hasColumns) {
    return items
  }

  const data = items.map(item => {
    const row = {}

    for (const { title, value } of columns) {
      const isPath = typeof value === "string"

      const path = isPath ? value : undefined
      const compute = !isPath ? value : undefined

      row[title] = ""

      if (path) {
        row[title] = get(item, path)
      }

      if (compute) {
        row[title] = compute(item)
      }
    }

    return row
  })

  return data
}

const ExportAction = ({ columns, fileName, getItems, title, type, shape, icon }) => {
  const { jsonToCSV } = usePapaParse()
  const [ isLoading, setIsLoading ] = useState(false)

  const onClick = () => {
    setIsLoading(true)

    const items = getItems()
    const data = getData(columns, items)

    const csv = jsonToCSV(data)
    const link = createDownload(`${fileName}_export`, csv)

    link.click()

    setTimeout(() => {
      const url = link.getAttribute("href")
      window.URL.revokeObjectURL(url)
    }, AFTER_DOWNLOAD_CLEANUP_DELAY)

    setIsLoading(false)
  }

  return (
    <Button
      icon={icon}
      type={type}
      shape={shape}
      onClick={onClick}
      loading={isLoading}
    >
      {title}
    </Button>
  )
}

ExportAction.propTypes = {
  columns: PropTypes.arrayOf(ExportColumnShape),
  fileName: PropTypes.string.isRequired,
  getItems: PropTypes.func.isRequired,
  title: PropTypes.string,
  shape: PropTypes.string,
  type: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.object,
}

ExportAction.defaultProps = {
  columns: [],
  title: null,
  shape: "circle",
  type: "dashed",
  icon: (<CloudDownloadOutlined />),
}

export default ExportAction
